import styled from "styled-components"

export const Carrinho = styled.div`
    width: 30%;
    height: 100%;
    max-width: 300px;
    min-width: 220px;
   
    color: green;
    display: flex;
    flex-direction: column;
    border-style: solid;
    border-radius: 4%;
    border-color: greenyellow;
    background-color: white;
    gap: 30px;
    padding: 30px 20px;
    align-items: center;

    
      
` 